import { getClassName } from './getClassName';
export var hasClass = function (element, className) {
    var classes = getClassName(element)
        .split(' ')
        .filter(function (cls) { return cls.length > 0; });
    return classes.indexOf(className) !== -1;
};
//# sourceMappingURL=hasClass.js.map